import cn from 'classnames'
import React, { ComponentPropsWithoutRef, FC, forwardRef } from 'react'

import styles from './AssetCardLayout.module.scss'

import Box from '~lib/ui-kit/Box/Box'

interface AssetCardLayoutChildProps extends ComponentPropsWithoutRef<'div'> {
  children: React.ReactNode
  className?: string
}

const Head: FC<React.PropsWithChildren<AssetCardLayoutChildProps>> = ({ children, className, ...props }) => {
  return (
    <div className={cn(styles.head, className)} {...props}>
      {children}
    </div>
  )
}

const Body: FC<React.PropsWithChildren<AssetCardLayoutChildProps>> = ({ children, className, ...props }) => {
  return (
    <div className={cn(styles.body, className)} {...props}>
      {children}
    </div>
  )
}

const Footer: FC<React.PropsWithChildren<AssetCardLayoutChildProps>> = ({ children, className, ...props }) => {
  return (
    <div className={cn(styles.footer, className)} {...props}>
      {children}
    </div>
  )
}

const Aside: FC<React.PropsWithChildren<AssetCardLayoutChildProps>> = ({ children, className, ...props }) => {
  return (
    <div className={cn(styles.aside, className)} {...props}>
      {children}
    </div>
  )
}

interface AssetCardLayoutProps extends ComponentPropsWithoutRef<'div'> {
  head?: React.ReactNode
  body?: React.ReactNode
  aside?: React.ReactNode
  footer?: React.ReactNode
  className?: string
}

const AssetCardLayout = forwardRef<HTMLElement, AssetCardLayoutProps>(
  ({ head, body, aside, footer, children, className, ...props }, ref) => {
    return (
      <Box ref={ref} className={cn(styles.root, className)} {...props}>
        {head}
        {aside ? (
          <div className={styles.center}>
            {aside}
            {body}
          </div>
        ) : (
          body
        )}
        {footer}
      </Box>
    )
  }
)

export default Object.assign(AssetCardLayout, {
  Aside,
  Head,
  Body,
  Footer,
})
